const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  id: "Icon"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.334 1.8335H14.1673C14.4435 1.8335 14.6673 2.05735 14.6673 2.3335V5.16683C14.6673 5.44297 14.4435 5.66683 14.1673 5.66683C13.8912 5.66683 13.6673 5.44297 13.6673 5.16683V3.50683L10.0007 7.16683C9.9162 7.27816 9.78688 7.34648 9.64732 7.3535C9.51461 7.35412 9.38724 7.30125 9.29398 7.20683C9.09902 7.01162 9.09902 6.69537 9.29398 6.50016L12.9473 2.8335H11.334C11.0578 2.8335 10.834 2.60964 10.834 2.3335C10.834 2.05735 11.0578 1.8335 11.334 1.8335ZM13.6673 14.0002V8.2935C13.6673 8.01735 13.4435 7.7935 13.1673 7.7935C12.8912 7.7935 12.6673 8.01735 12.6673 8.2935V14.0002C12.6673 14.0922 12.5927 14.1668 12.5007 14.1668H2.50065C2.4086 14.1668 2.33398 14.0922 2.33398 14.0002V4.00016C2.33398 3.90812 2.4086 3.8335 2.50065 3.8335H8.22732C8.50346 3.8335 8.72732 3.60964 8.72732 3.3335C8.72732 3.05735 8.50346 2.8335 8.22732 2.8335H2.50065C1.85783 2.83714 1.33763 3.35735 1.33398 4.00016V14.0002C1.33763 14.643 1.85783 15.1632 2.50065 15.1668H12.5007C13.1435 15.1632 13.6637 14.643 13.6673 14.0002Z"
}));

const SvgExternal = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExternal, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/external.4c14787d.svg";
export { ForwardRef as ReactComponent };